<div class="subheader with-padding flgrow">
  <div class="row">
    <div class="col-md-3">
      <div class="flmid">
        <div class="flgrow">
          <div class="input-group">
            <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
              [(ngModel)]="pService.searchTerm" autocomplete="off" />
            <div class="input-group-append">
              <button type="button" class="btn btn-primary">
                <em class="fa fa-search"></em>
              </button>
            </div>
          </div>
        </div>
        <div class="ml-2 advanced-search-box">
          <button type="button" class="btn btn-primary" (click)="onSearch()" aria-label="Center Align">
            <i class="fa fa-search-plus" aria-hidden="true"></i>
          </button>
          <div class="searchbox card fix lt" *ngIf="dealerServiceRequestModel.isAdvanceSearch">
            <div class="form-row mb-3">
              <div class="col-md-4">
                <label for="status"><span translate>lblStatus</span></label>
                <ng-select placeholder="{{ 'lblSelectStatus' | translate }}" [(ngModel)]="selectedStatus"
                  (change)="StatusChange($event,true)">
                  <ng-option *ngFor="let status of StatusList" [value]="status.id">
                    {{status.value}}
                  </ng-option>
                </ng-select>
              </div>

              <div class="col">
                <label for="template-name" translate>lblSerivceName </label>
                <div class='lbl-info'>
                  <input type="text" id="template-name" name="name" placeholder="{{ 'lblEnterValue' | translate }}"
                    [(ngModel)]="dealerServiceRequestModel.name" class="form-control" maxlength="100">
                </div>
              </div>
              <div class="col">
                <label for="template-serviceNo" translate>lblServiceNo </label>
                <div class='lbl-info'>
                  <input type="text" id="template-serviceNo" name="serviceNo"
                    placeholder="{{ 'lblEnterValue' | translate }}" [(ngModel)]="dealerServiceRequestModel.serviceNo"
                    class="form-control" maxlength="100">
                </div>
              </div>
            </div>
            <div class="form-row mb-3">
              <div class='col-md-4' *ngIf="dealerList && dealerList.length > 0">
                <label translate>lblSelectDealer</label>
                <app-dealer-searchbox-dropdown [dealerList]="dealerList" 
                    ngDefaultControl name="advanceDealerDropdown" [selectedDealer]="selectedDealerId"
                    (onSelectDealer)="onDealerSelected($event,'advanceSearchDealerDropdown')"
                    placeholder="Search Dealer">
                </app-dealer-searchbox-dropdown>
            </div>
              <div class="col-md-4">
                <label for="template-description" translate>lblDescription </label>
                <div class='lbl-info'>
                  <input type="text" id="template-description" name="description"
                    placeholder="{{ 'lblEnterValue' | translate }}" [(ngModel)]="dealerServiceRequestModel.description"
                    class="form-control" maxlength="100">
                </div>
              </div>
              <div class="col-md-4">
                <label for="template-serviceCategoryName" translate>lblWidgetServiceCategory </label>
                <div class='lbl-info'>
                  <input type="text" id="template-serviceCategoryName" name="serviceCategoryName"
                    placeholder="{{ 'lblEnterValue' | translate }}"
                    [(ngModel)]="dealerServiceRequestModel.serviceCategoryName" class="form-control" maxlength="100">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <label for="template-dealerName" translate>lblNeedAttention </label>
                <div class='lbl-info'>
                  <div class="form-check pl-0">
                    <input type="checkbox" [checked]="needAttention" id="customCheck1"
                        (change)="changeNeedAttention($event)" />
                </div>
                </div>
              </div>
              <div class="col-4">
                <label for="template-description" translate>lblFixedPrice </label>
                <div class='lbl-info'>
                  <div class="form-check pl-0">
                    <input type="checkbox" [checked]="isFixed" id="customCheck1"
                        (change)="OnChangeClick($event)" />
                </div>
              </div>
              </div>
              <div class="col-4">
                <label for="template-description" translate>lblDisplayPriceInWidget </label>
                <div class='lbl-info'>
                  <div class="form-check pl-0">
                    <input type="checkbox" [checked]="displayPriceInWidget" id="customCheck1"
                        (change)="DisplayPriceInWidget($event)" />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <label for="template-dealerName" translate>lblRecommendedService </label>
              <div class='lbl-info'>
                <div class="form-check pl-0">
                  <input type="checkbox" [checked]="isRecommended" id="customCheck1" (change)="changeRecommendedService($event)" />
                </div>
              </div>
            </div>
          </div>
            <hr />
            <div class="row">
              <div class="col text-right">
                <button type="submit" (click)="AdvanceSearchSubmit()" class="btn btn-primary mr-sm-2" translate>lblApply
                </button>
                <button (click)="onReset()" class="btn btn-outline-tertiary mr-sm-3" translate>lblReset
                </button>
                <button (click)="onClose()" class="btn btn-outline-tertiary" translate>lblClose
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-2 pl-4" *ngIf="dealerList && dealerList.length > 0">
      <div class="relative flmid">
        <div class="flgrow">
          <app-dealer-searchbox-dropdown [dealerList]="dealerList" [selectedDealer]="selectedDealerId" ngDefaultControl
            name="dealerDropdown" (onSelectDealer)="onDealerSelected($event,'dealerDropdown')" placeholder="Search Dealer">
          </app-dealer-searchbox-dropdown>
        </div>
      </div>
    </div>
    <div class="col-auto ml-auto" *ngIf="userRoleRightsDetails.canAdd">
      <button type="button" (click)="onAdd()" type="reset" aria-label="Center Align" class="add-button btn btn-primary"
        translate>lblAddDealerService</button>
    </div>
  </div>
</div>
<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex">
          <h4 class="card-title" translate>lblDealerService</h4>

        </div>
        <div class="table-responsive">
          <table class="tablest1">
            <thead>
              <tr>
                <th style="width: 55px" scope="col">#</th>
                <th style="width: 10%" scope="col" sortable="serviceNo" (sort)="onSort($event)" translate>
                  lblServiceNumber</th>
                <th style="width: 15%" scope="col" sortable="name" (sort)="onSort($event)" translate>lblName</th>
                <th style="width: 15%" scope="col" sortable="dealerName" (sort)="onSort($event)" translate>lblDealerName
                </th>
                <th style="width: 8%" scope="col" class="text-right" sortable="price" (sort)="onSort($event)" translate>
                  lblPrice
                </th>
                <th style="width: 8%" class="text-right" scope="col" sortable="duration" (sort)="onSort($event)"
                  translate>lblDuration</th>
                <th style="width: 30%" scope="col" translate>lblDescription</th>
                <th style="width: 15%" class="text-center" scope="col" sortable="isRecommended" (sort)="onSort($event)"
                  translate>lblIsRecommended
                </th>
                <th style="width: 15%" scope="col" translate>lblWidgetServiceCategory</th>
                <th style="width: 15%" scope="col" class="text-center" sortable="isActive" (sort)="onSort($event)"
                  translate>
                  lblActive
                </th>
                <th style="width: 120px" scope="col" translate class="text-center">lblAction</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="dealerServiceList?.length>0; else load_else">
                <tr *ngFor="let dealerService of dealerServiceList; let i=index">
                  <td>{{ dealerService.rowNumber }}</td>
                  <td>
                    <ngb-highlight [result]="dealerService.serviceNo" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="dealerService.name" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="dealerService.dealerName" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td class="text-right nowrap">
                    <ngb-highlight [result]="dealerService.price | stringToNumber | number:'1.2-2'" [term]="pService.searchTerm">
                    </ngb-highlight>
                  </td>

                  <td class="text-right">
                    <ngb-highlight [result]="dealerService.duration" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="dealerService.description" [term]="pService.searchTerm">
                    </ngb-highlight>
                  </td>
                  <td class="text-center">
                    <em class="fas fa-check" *ngIf="dealerService.isRecommended"></em>
                    <em class="fas fa-close" *ngIf="!dealerService.isRecommended"></em>
                  </td>
                  <td>
                    <ngb-highlight [result]="dealerService.serviceCategoryName? dealerService.serviceCategoryName: ''"
                      [term]="pService.searchTerm">
                    </ngb-highlight>
                  </td>
                  <td class="text-center">
                    <em class="fas"
                      [ngClass]="{'fa-check': dealerService.isActive, 'fa-close': !dealerService.isActive}"></em>
                  </td>
                  <td class="nowrap text-center">
                    <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert"
                      *ngIf="userRoleRightsDetails.canEdit" (click)="editDealerService(dealerService)">
                      <em class="fas fa-pencil-alt fa-lg"></em>
                    </a>
                    <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                    <a class="btn btn-ico" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                      *ngIf="userRoleRightsDetails.canDelete" (click)="deleteDealerService(dealerService.id)">
                      <em class="far fa-trash-alt fa-lg"></em>
                    </a>


                  </td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                </tr>
              </ng-template>
            </tbody>
          </table>

        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-between">
            <div class="d-flex justify-content-between">
              <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page"
                [pageSize]="pService.pageSize" [maxSize]="3">
              </ngb-pagination>
              <select class="custom-select mx-2" style="width: auto" name="pageSize" [(ngModel)]="pService.pageSize">
                <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>{{item.label}}
                </option>
              </select>
            </div>
            <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
              <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$ | async}}&nbsp;<span
                class="font17 fontnormal" translate>lblResults</span>
            </div>

          </div>
        </div>

      </div>

    </div>
  </div>

</div>